export default __webpack_public_path__ + "static/media/padel-head-tour.66c2ad5e.png";